import { useBrowseCompaniesApi } from '@aibees/elephant/api';
import { SuggestionSearchBarOptionBase } from '@aibees/elephant/feature/suggestion-search-bar';
import { Maybe, PaginationResponse } from '@aibees/shared/definition';

export function useAutoSuggestedCompanies(search: Maybe<string>) {
  return useBrowseCompaniesApi<SuggestionSearchBarOptionBase>(
    {
      return: 'linkedin',
      ...(search && { search }),
      size: 10,
      page: 0,
    },
    {
      select: (data) => {
        const content = data?.content.map(
          (x) =>
            ({
              canSimilaritySearch: x.canSimilaritySearch,
              id: x.id,
              value: x.link?.linkedin,
              label: x.summary?.name,
              logo: x.summary?.logo?.source,
              description: x.summary?.industry,
              fullData: x,
            } as SuggestionSearchBarOptionBase)
        ) as SuggestionSearchBarOptionBase[];
        return {
          ...data,
          ...{ content },
        } as PaginationResponse<SuggestionSearchBarOptionBase>;
      },
    }
  );
}
